import ChattaCommunityTemplateScreen from '~components/new-chat/school/template/[templateId]'

export default ChattaCommunityTemplateScreen
